/* -----------------------------------------------------------
   OPEN CART DRAWER WHEN CLICKING HEADER CART LINK
----------------------------------------------------------- */
document.addEventListener('click', function (event) {
  var cartLink = event.target.closest('.hosome-header__cart-link');
  if (!cartLink) return;

  // prevent going to /cart
  event.preventDefault();

  // Correct Minimog event to OPEN the drawer
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    })
  );
});

/* -----------------------------------------------------------
   CLOSE CART DRAWER WHEN CLICKING CLOSE ICON OR OVERLAY
----------------------------------------------------------- */
document.addEventListener('click', function (event) {
  var closeBtn = event.target.closest('.m-cart-drawer__close');
  var overlay = event.target.closest('.m-cart__overlay');
  if (!closeBtn && !overlay) return;

  // Correct Minimog event to CLOSE drawer
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: false }
    })
  );
});

// Helper: update header cart text everywhere
  function hosomeUpdateHeaderCartCount(count) {
    count = count || 0;

    // Your custom header link text: "Cart (X)"
    var cartText = document.querySelector('.hosome-header__cart-link .cart-text');
    if (cartText) {
      cartText.textContent = 'Cart (' + count + ')';
    }

    // Optional: if you ever add bubbles like <span data-cart-count>
    var countBubbles = document.querySelectorAll('[data-cart-count]');
    countBubbles.forEach(function (el) {
      el.textContent = count;
    });
  }

  // 1) When Minimog says "cart updated" (drawer, product form, etc.)
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') {
      hosomeUpdateHeaderCartCount(cart.item_count);
    } else {
      // Fallback – fetch cart if for some reason cart object is missing
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cartData) {
          hosomeUpdateHeaderCartCount(cartData.item_count);
        })
        .catch(function (err) {
          console.error('Failed to sync header cart count', err);
        });
    }
  });

  // 2) Optional: sync once on page load too
  document.addEventListener('page:loaded', function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cartData) {
        hosomeUpdateHeaderCartCount(cartData.item_count);
      })
      .catch(function (err) {
        console.error('Failed to sync header cart count on load', err);
      });
  });

// Explore js for inner header
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".explore-inner");

  if (btn) {
    btn.addEventListener("click", function (event) {
      event.preventDefault(); 

      // Find the parent .shopify-section of the button
      const currentSection = btn.closest(".shopify-section");
      if (!currentSection) return;

      // Find the next .shopify-section
      const nextSection = currentSection.nextElementSibling;
      if (!nextSection) return;

      // Optional scroll offset
      const offset = 60;

      const elementPosition = nextSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".hosome-explore");

  buttons.forEach(btn => {
    btn.addEventListener("click", function (event) {
      event.preventDefault();

      const selector = btn.dataset.scrollTarget;
      const target = document.querySelector(selector);

      if (target) {
        const offset = 50;

        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});

(function () {
    const el = document.querySelector('.sticky-el');
    if (!el) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 800) {
        el.classList.add('is-fixed');
      } else {
        el.classList.remove('is-fixed');
      }
    });
})();